import { BoxProps, CSSObject } from '@chakra-ui/react';

export const wrapper: BoxProps = {};
export const FlexResponsibleGamblingBannerWrapper: CSSObject = {
  boxShadow: 'none',
};
